import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import settings from '../../../config/settings';
import InputValidator from '../common/InputValidator.jsx';
import validatedComponent from '../common/ValidatedComponent.jsx';
import {createProfile} from '../profile/redux/actions';
import * as Actions from './redux/actions';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {FacebookAuthButton, TwitterAuthButton} from './SocialAuthButtons.jsx';
import qs from 'qs';

class Signup extends React.Component {
  constructor() {
    super();

    this.state = {
      company: '',
      email: '',
      password: '',
      confirmPassword: '',
      firstName: '',
      lastName: '',
      referralCode: '',
      acceptTerms: _.get(settings, 'website.automaticAccountAgreement'),
      acceptConsent: false,
      inputState: null
    };

    this.createUser = this.createUser.bind(this);
    this.validateConfirmPassword = this.validateConfirmPassword.bind(this);
  }

  componentDidMount() {
    this.getReferralCode();
  }

  getReferralCode() {
    const {referral_code} = qs.parse(document.location.search); // eslint-disable-line camelcase
    this.setState({referralCode: referral_code});
  }

  createUser(event) {
    event.preventDefault();
    const {context, state} = this;

    if (context.isComponentValid()) {
      this.props.createProfile({
        email: state.email,
        password: state.password,
        firstName: state.firstName,
        lastName: state.lastName,
        referralCode: state.referralCode
      });
    }
  }

  onChange(fieldName, e) {
    this.state[fieldName] = e.target.value;
    this.setState(this.state);
  }

  validateConfirmPassword() {
    const {password, confirmPassword} = this.state;
    if (password && confirmPassword && password !== confirmPassword) {
      return 'Both passwords must be equal';
    }
  }

  render() {
    const {state} = this;
    const {
      errors, socialLoginOAuth1Step1, socialLoginOAuth1Step2, socialLoginOAuth2,
      provider, oauthToken, oauthTokenSecret, isNoEmailProvidedError
    } = this.props;
    return (
      <div className="ba-signup row">
        <Helmet title="Sign up"/>
        <form noValidate>
          <div className="panel small-12 small-centered columns">
            <div className="row panel-title">
              <h3>Create an Account</h3>
            </div>
            <div className="row">
              <InputValidator fieldName="First Name"
                              shouldValidateOnBlur={true}>
                <input type="text"
                       name="firstName"
                       placeholder="First Name"
                       value={state.firstName}
                       onChange={this.onChange.bind(this, 'firstName')}/>
              </InputValidator>
            </div>
            <div className="row">
              <InputValidator fieldName="Last Name"
                              shouldValidateOnBlur={true}>
                <input type="text"
                       name="lastName"
                       placeholder="Last Name"
                       value={state.lastName}
                       onChange={this.onChange.bind(this, 'lastName')}/>
              </InputValidator>
            </div>
            <div className="row">
              <InputValidator fieldName="Email"
                              errors={errors.email}
                              shouldValidateOnBlur={true}>
                <input type="email"
                       name="email"
                       placeholder="Email*"
                       required
                       onChange={this.onChange.bind(this, 'email')}
                       value={state.email}/>
              </InputValidator>
            </div>
            <div className="row">
              <InputValidator fieldName="Password"
                              errors={errors.password}
                              shouldValidateOnBlur={true}
                              customValidation={() => {
                                return this.validateConfirmPassword();
                              }}
                              className={this.state.inputState}>
                <input type="password"
                       name="password"
                       placeholder="Password*"
                       required
                       onChange={this.onChange.bind(this, 'password')}
                       value={state.password}/>
              </InputValidator>
            </div>
            <div className="row">
              <InputValidator fieldName="Confirm Password"
                              shouldValidateOnBlur={true}
                              customValidation={() => {
                                return this.validateConfirmPassword();
                              }}
                              className={this.state.inputState}>
                <input type="password"
                       name="password-confirm"
                       placeholder="Confirm Password*"
                       required
                       onChange={this.onChange.bind(this, 'confirmPassword')}
                       value={state.confirmPassword}/>
              </InputValidator>
            </div>
            <div className="row">
              {!_.get(settings, 'website.automaticAccountAgreement') ?
                <div className="large-12 columns">
                  <InputValidator fieldName="Terms and Conditions"
                                  errors={errors.acceptTerms}>
                    <input type="checkbox"
                           id="terms"
                           name="terms-and-conditions"
                           value="accept_terms"
                           checked={state.acceptTerms}
                           onChange={e => this.setState({acceptTerms: e.target.checked})}/>
                    <label htmlFor="terms">
                      I agree to the
                      <a href="/equity-terms"
                         target="_blank"
                         rel="noopener noreferrer">Terms of Use</a>,
                      <a href="/equity-privacy"
                         target="_blank"
                         rel="noopener noreferrer"> Privacy Policy</a> and
                      <a href="/compensation"
                         target="_blank"
                         rel="noopener noreferrer"> Compensation Disclaimer</a>.
                    </label>
                  </InputValidator>
                </div>
                : null }
              <div className="large-12 columns">
                <InputValidator fieldName="Electronic Materials Consent"
                                errors={errors.acceptConsent}>
                  <input type="checkbox"
                         id="consent"
                         name="consent"
                         value="accept_consent"
                         checked={state.acceptConsent}
                         onChange={e => this.setState({acceptConsent: e.target.checked})}/>
                  <label htmlFor="consent">
                    I consent to the delivery of electronic materials relating to business conducted
                    through {_.get(settings, 'website.title')}.
                  </label>
                </InputValidator>
              </div>
            </div>
            <div className="row text-center">
              <button type="button"
                      name="btn-create"
                      className="ba-default-button"
                      disabled={!state.acceptConsent || !state.acceptTerms}
                      onClick={this.createUser}>
                Create Account
              </button>
            </div>
            { (_.get(settings, 'website.socialLogins')) ?
              <div className="row text-center ba-login-social">
                <div className="large-12 columns">Or create one with an existing social account</div>
                <div className="large-12 columns">
                  <FacebookAuthButton fbAppId={settings.fbAppId}
                                      onSendAuthRequest={socialLoginOAuth2.bind(this)}
                                      isNoEmailProvidedError={isNoEmailProvidedError && provider === 'facebook'}/>
                  <TwitterAuthButton oauthToken={oauthToken}
                                     oauthTokenSecret={oauthTokenSecret}
                                     onRetrieveAuthRequestToken={socialLoginOAuth1Step1.bind(this)}
                                     onSendAuthRequest={socialLoginOAuth1Step2.bind(this)}
                                     isNoEmailProvidedError={isNoEmailProvidedError && provider === 'twitter'}/>
                </div>
              </div>
              : null }
            {_.get(settings, 'website.automaticAccountAgreement') ?
              <div className="row text-center">
                <div className="large-12 columns">
                  By signing up, you agree to the
                  <a href="/equity-terms"
                     target="_blank"
                     rel="noopener noreferrer"> Terms of Use</a>,
                  <a href="/equity-privacy"
                     target="_blank"
                     rel="noopener noreferrer"> Privacy Policy</a> and
                  <a href="/compensation"
                     target="_blank"
                     rel="noopener noreferrer"> Compensation Disclaimer</a>.
                </div>
              </div>
              : null }
          </div>
        </form>
        <div className="push"/>
      </div>
    );
  }
}

Signup.displayName = 'Signup';

Signup.contextTypes = {
  router: PropTypes.object.isRequired
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({...Actions, createProfile}, dispatch);
}

function mapStateToProps(state) {
  const {oauthToken, oauthTokenSecret, isNoEmailProvidedError, provider} = state.auth;
  return {...state.signup, oauthToken, oauthTokenSecret, isNoEmailProvidedError, provider};
}

export default connect(mapStateToProps, mapDispatchToProps)(validatedComponent(Signup));



// WEBPACK FOOTER //
// ./shared/auth/Signup.jsx